<nav class="navbar" (mouseenter)="isShrinked = false" (mouseleave)="isShrinked = true" [ngClass]="{'navbar--shrinked': isShrinked}">
  <ul class="navbar__list">
    <li class="navbar__list__item"  *ngFor="let item of navService.visibleItems" [routerLink]="item.route" routerLinkActive="active" [ngClass]="{'navbar__list__item--active': item.active}" (click)="navService.closeMobileMenu()">
      <div class="navbar__list__item__iconDiv">
        <mat-icon class="navbar__list__item__icon" matListIcon>{{ item.icon }}</mat-icon>
        <span class="navbar__list__item__notification"
          *ngIf="item.quantidadeNotificacoes"
          >{{ item.quantidadeNotificacoes }}</span
        >
      </div>
      <span class="navbar__list__item__title" matLine>{{ item.name }}</span>
    </li>
  </ul>

  <ul class="navbar__list navbar__list--footer">
    <li class="navbar__list__item" routerLink="/logout" routerLinkActive="active">
      <mat-icon class="navbar__list__item__icon" matListIcon>exit_to_app</mat-icon>
      <span class="navbar__list__item__title" matLine>Fazer Logout</span>
    </li>
  </ul>
</nav>